import { createContext, useMemo } from 'react'

type ChartCustomizerContextType = Props

type Props = React.PropsWithChildren<{
  onClickEditLineChart: () => void
  onEditTotalValue: (value: number | string) => void
}>

export const ChartCustomizerContext =
  createContext<ChartCustomizerContextType | null>(null)

export const ChartCustomizerProvider: React.FC<Props> = ({
  children,
  onClickEditLineChart,
  onEditTotalValue,
}) => {
  const contextValue = useMemo(
    () => ({ onClickEditLineChart, onEditTotalValue }),
    [onClickEditLineChart, onEditTotalValue],
  )

  return (
    <ChartCustomizerContext.Provider value={contextValue}>
      {children}
    </ChartCustomizerContext.Provider>
  )
}
